<template>
  <div class = "complex-table" :style="{width}">
       <div class = "complex-table-container">
             <el-table
                 ref="table"
                 :data="data" 
                 :fit = "optionsData.fit"
                 :default-sort = "optionsData.defaultSortOptions" 
                 :header-cell-style ="optionsData.headerCellStyle"
                 style="width: 100%" 
                 :row-style = "optionsData.rowStyle"
                 @row-click = "rowClickHandler"
                 @cell-click = "cellClickHandler"
             >
                 <el-table-column v-for='(col,tempIndex) in optionsData.columns'
                     :prop="col.field"
                     :label="col.title" 
                     :key="col.field+tempIndex"
                     :fixed="col.fixed"
                     :sortable = "col.sortable"
                     :min-width="col.width"
                     >
                     <template  slot-scope="scope">
                         <span v-if="col.field == 'OP'">
                              <div class="btn-box">
                                <template v-if="scope.row.actionList1.length">
                                  <el-button v-for="(item, index) in scope.row.actionList1" :key="index" type="text" round
                                    @click="item.btnHandler">{{ item.text}}</el-button>
                                </template>
 
                                <template  v-if="scope.row.actionList2.length"> 
                                  <el-popover ref="popover" placement="bottom" width="150" popper-class="busi-query-popover" 
                                    trigger="hover" > 
                                    <el-button v-for="(item, index) in scope.row.actionList2" :key="index" type="text" class="temp-el-button" round
                                      @click="handleBtnClick(scope, item)">{{ item.text }}</el-button> 
                                      <el-button type="text" slot="reference">更多<i
                                        class="el-icon-arrow-down el-icon--right"></i></el-button>
                                  </el-popover>
                                </template>
                              </div> 
                         </span>
                         <span v-else>{{columnFormatter(scope.row,col)}}</span>
                     </template>
                 </el-table-column>
             </el-table>
       </div>   
       <div class = 'kui-table-footer' v-show = "optionsData.isShowFooter !== false">
             <el-pagination
                 :background="isBackGround"
                 @size-change="paginationSizeChangeHandler"
                 @current-change="paginationCurrentChangeHandler"
                 :current-page="page.currentPage"
                 :page-sizes="pageList"
                 :page-size="page.pageSize"
                 :layout="pageLayout"
                 :total="page.totalCount"
             ></el-pagination>
       </div>
   </div>
</template>

<script>
import dict from "@/tools/dict";
import dateUtils from "@/tools/date";
const initTableData = (_this) => {
  _this.page.currentPage = 1;
  _this.page.pageOffset = 1; 
  return _this.getData().then(() => {
    _this.$nextTick(() => {
      _this.resize();
    });  
  });
};

const getOriginalData = (_this,params, isReset) => {
  if(_this.optionsData.data && _this.optionsData.data.length) {
    var data = _.filter(_this.optionsData.data || [], obj => {
      var flag = true;
      _.isObject(params) && _.each(params, (v,k) => {
        if(obj[k] !== undefined && obj[k] !== v) {
          flag = false;
        }
      });
      return flag;
    });
    var res = {
      data: data || [],
      total: data.length || 0
    };
    return Promise.resolve(res);
  }else {
    return Promise.resolve({
      data:[],
      total:0
    });
  }
};

const getColmunsOptions = async (_this) => {
  let requestArr = [];
  var columns = _.cloneDeep(_this.options.columns || []);
  var dicts = _.chain(columns || []).filter(v=> !!v.dict).map(obj => obj.dict).value();
  _.each(columns || [], obj => {
    obj.editor = {
      options: {
        valueField: obj.valueField || "dict_val",
        textField: obj.textField || "dict_des",
        valueSeparator: obj.valueSeparator != undefined ? obj.valueSeparator : ",",
      }
    };
       
    if(obj.data && obj.data.length) {
      requestArr.push(()=> {
        return {
          field:obj.field,
          data: obj.data
        };
      });
    } 
  });
  let res = await Promise.all(_.map(requestArr, func => func()));
  let dictData = await dict.getDictData(dicts);

  _.each(columns || [], (obj,index) => {
    var reqRes = _.find(res, v => v.field === obj.field);
    obj.editor.options.data = reqRes && reqRes.data || [];
    obj.editor.options.dict = _.map(dictData[obj.dict || ""] || [], dictTemp=> {
      return {
        dict_val: dictTemp.DICT_ITEM,
        dict_des: dictTemp.DICT_ITEM_NAME
      };
    });
      
  });
  return columns;
};

const formatterText = (val, data, valueField,textField, valueSeparator)=> {
  let textFieldArr = textField.split(",") || [];
  var valArr = val.split(valueSeparator) || [];
  var valTextArr = [];
  _.each(valArr, val=> {
    let res = _.find(data, obj=> obj[valueField] === val);
    if(!res) {
      valTextArr.push(val);
      return;
    }
    let resStr = _.map(textFieldArr, text => res[text]);
    valTextArr.push(resStr.join("-"));
  });
  if(!valueSeparator) {
    return valTextArr.join(",");
  }
  return valTextArr.join(valueSeparator);
};
const getColumnToolbar = (_this, rowData) => {
  var hasOpColumnsConfObj = _.find(_this.optionsData.columns, obj => obj.field == "OP") || {};
  var toolbar = [];
  if(_.isArray(hasOpColumnsConfObj.toolbar)) {
    toolbar = _.map(hasOpColumnsConfObj.toolbar, tempObj => {
      return Object.assign({},tempObj, {
        handler:(event)=> {
          return _.isFunction(tempObj.btnHandler) && tempObj.btnHandler(rowData, hasOpColumnsConfObj);
        }
      });
    });
  }else if(_.isFunction(hasOpColumnsConfObj.toolbar)) {
    toolbar= _.map(hasOpColumnsConfObj.toolbar(rowData), tempObj => {
      return Object.assign({},tempObj, {
        handler:(event)=> {
          return _.isFunction(tempObj.btnHandler) && tempObj.btnHandler(rowData, hasOpColumnsConfObj);
        }
      });
    });
  }
  return  toolbar || [];
};

const formatterBtnConf = (_this) => {
  _.each(_this.data, (obj,index) => {
    var toolbar = getColumnToolbar(_this,obj);
    _.each(_this.$refs["opBtnRefs"+index] || [], buttonRef => {
      buttonRef && buttonRef.button({buttonGroup:toolbar});
    });
  });
};

/**
     * px转换为vm方法
     *  @param value 传入的px值
     * */
const pxToVw = (value) =>{
  value = value + "";
  const pxGlobRegExp = new RegExp(/(\d+)/.source, "ig");
  /**
         * px转换为vm方法
         *  @param minPixelValue 小于或等于`1px`时不转换为视窗单位,默认为1
         *  @param unitPrecision 指定`px`转换为视窗单位值的小数位数，默认为3个小数点
         *  @param viewportSize  横屏时使用的视窗宽度 取window.sreen.height
         * */
  const createPxReplace = function (minPixelValue, unitPrecision, viewportSize){
    return function (m, $1) {
      if (!$1) return m;
      var pixels = parseFloat($1);
      if (pixels <= minPixelValue) return m;
      var parsedVal = (pixels / viewportSize * 100);
      return parsedVal === 0 ? 0 : parsedVal.toFixed(unitPrecision) + "vw";
    };
  };
  return value.replace(pxGlobRegExp, createPxReplace(1, 3, document.documentElement.clientWidth));
};

export default {
 
  data: function () {
    return {
      originalRows: [],
      columnsConf: [],
      data:[],
      height: "auto",
      page: {
        currentPage: 1, 
        pageOffset: 1,
        pageSize: 5, // 每页显示条目个数
        totalCount: 0 // 总条目数
      },
      queryFormShow: false,
      queryFormHeight:"auto",
      optionsData:{},
    };
  },
  props: {
    options:{
      type:Object,
      default: ()=>{
        return {};
      }
    }
  },
  computed: {
    width () {
      if(this.optionsData.width&&this.optionsData.width.includes("%")){
        return  this.optionsData.width;
      }
      return this.optionsData.width?( pxToVw(parseInt(this.optionsData.width) || 600)):"";
    },
    pageList () {
      return this.optionsData.pageList || [10, 20, 30, 100];
    },
    pageLayout () {
      return this.optionsData.pageLayout || "total, sizes, prev, next, jumper";
    },
    isBackGround () {
      return this.optionsData.isBackGround || false;
    }
  },
  watch: {
    "options.columns": {
      deep: true,
      immediate: true,
      handler () {
        return getColmunsOptions(this).then((conf) => {
          this.columnsConf = conf;
        });
      }
    }
  },
  mounted () {
    this.optionsData = this.options;
    initTableData(this);
  }, 
  methods: {
    table (opts,...params){
      if(_.isString(opts)){
        if(params.length>1){
          return this[opts].call(this,params[0],params[1]);
        }else{
          return this[opts].call(this,params[0]);
        }
      }else{
        //传进来参数是对象 就和options合并 并赋值
        _.assign(this.optionsData, this.options,opts);
        initTableData(this);
        return this;
      }
    }, 
    resize () {
      if(this.optionsData.fit) {
        var $tableTitle = this.$parent.$el.getElementsByClassName("kui-table-title")[0];
        var $tableQuery = this.$parent.$el.getElementsByClassName("kui-table-query")[0];
        var $tableFooter = this.$parent.$el.getElementsByClassName("kui-table-footer")[0];
        var height = this.$parent.$el.clientHeight - $tableTitle.clientHeight - $tableQuery.clientHeight - $tableFooter.clientHeight;
        this.height = pxToVw(height);
      }else {
        this.height = this.optionsData.height ? pxToVw(this.optionsData.height) : "auto";
      }
   
      this.$nextTick(() => {
        if(this.optionsData.loadDataAfter && _.isFunction(this.optionsData.loadDataAfter)) {
          this.optionsData.loadDataAfter.call(this,this.originalData);
        }
      });
    },
    loadData (data,totalCount) {
      let that =this;
      return Promise.all([
        _.isFunction(that.optionsData.loadFilter) ? that.optionsData.loadFilter(data) : data
      ]).then((res) => {
        that.$set(that, "data", res[0]);
        that.page.totalCount = totalCount || 0; 
        //数据过滤成功之后的回调
        _.isFunction(that.optionsData.onLoadSuccess) && that.optionsData.onLoadSuccess(res[0],that.page.totalCount);
        // that.$nextTick(() => {
        //   formatterBtnConf(that);
        // });
      });
    },
    paginationSizeChangeHandler (val) {
      this.page.pageSize = val;
      this.page.pageOffset = (this.page.currentPage - 1) *  this.page.pageSize + 1;
      // return this.getData(undefined, false);
      this.$emit("on-change",val);
    },
    paginationCurrentChangeHandler (val) {
      this.page.currentPage = val;
      //切换页码后，table滚动条回到表头
      this.$refs.table.bodyWrapper.scrollTop = 0;
      this.page.pageOffset = (this.page.currentPage - 1) *  this.page.pageSize + 1;
   
      this.$emit("on-change",val);
    },
    
    getData (params, isReset) { 
      // this.$store.commit(this.$types.UPDATE_LOADING, "正在加载数据，请稍候..."); 
      return getOriginalData(this, params, isReset).then((res) => {
        this.originalData = res.data;
        this.page.totalCount = res.total;
        this.loadData(this.originalData);
      }).finally(()=>{
      //  this.$store.commit(this.$types.UPDATE_LOADING, false); 
      });    
    },
    columnFormatter (row, col) {
      var column = _.find(this.columnsConf || [], (obj) => {
        return obj.field == col.field;
      }) || {};
      if(column.formatter && _.isFunction(column.formatter)) {
        return column.formatter(row[column.field], row, column);
      }else if(column.dict && column.editor.options.dict && column.editor.options.dict.length){
        return formatterText(row[column.field], column.editor.options.dict, column.editor.options.valueField, column.editor.options.textField, column.editor.options.valueSeparator);
      }else if((column.req || (column.data && column.data.length)) && column.editor.options.data && column.editor.options.data.length) {
        return formatterText(row[column.field], column.editor.options.data, column.editor.options.valueField, column.editor.options.textField, column.editor.options.valueSeparator);
      }
      // var isDateTime = false;
      // var fieldVal = row[column.field] || ""; 
      // if(fieldVal.match(/^(\d{4})\D(\d{1,2})\D(\d{1,2})$/)){
      //   isDateTime = dateUtils.isValidDate(dateUtils.parseDate(fieldVal.trim())); 
      //   var splitDateTimeArr = fieldVal.trim().split(/\s/);
      //   if(isDateTime && splitDateTimeArr.length > 1){//对YYYY-MM-DD HH:MM:SS 格式字符串做换行处理，搭配css white-space: pre-wrap使用
      //     row[column.field] = splitDateTimeArr.join("\n");
      //   }
      // }
    
      return row[column.field];
    },
    queryBtnHandler () {
      this.queryFormShow = !this.queryFormShow;
      this.$nextTick(() => {
        var $elDrawerBody = this.$el.querySelector(".el-drawer__body");
        this.queryFormHeight = (parseInt(pxToVw($elDrawerBody.clientHeight))-parseInt(pxToVw(130))) + "vw";
      });
    }, 
    queryFormOpened () {
      if(this.optionsData.queryFormOpenAfter && _.isFunction(this.optionsData.queryFormOpenAfter)) {
        this.optionsData.queryFormOpenAfter.call(this.$refs.tableQueryForm,this.originalData);
      }
    },
    rowClickHandler (row, column, event) {
      if(this.optionsData.rowClickHandler && _.isFunction(this.optionsData.rowClickHandler)) {
        this.optionsData.rowClickHandler.call(this, row, column, event);
      }
    },
    cellClickHandler (row, column, cell, event) {
      if(this.optionsData.cellClickHandler && _.isFunction(this.optionsData.cellClickHandler)) {
        this.optionsData.cellClickHandler.call(this, row, column, cell, event);
      }
    },
    handleBtnClick (scope, item){
      item.btnHandler();
    },
    reload () {
      var quaryParams = this.$refs.tableQueryForm.form("getData");
      //   var maskLoading = loading("正在加载数据，请稍候...");
      this.$store.commit(this.$types.UPDATE_LOADING, "正在加载数据，请稍候..."); 
      return Promise.all([
        _.isFunction(this.optionsData.queryFormBeforeSave) ? this.optionsData.queryFormBeforeSave.call(this.$refs.tableQueryForm, quaryParams) : quaryParams
      ]).then(([params]) => {
        return this.getData(params);
      }).finally(()=> {
        this.$store.commit(this.$types.UPDATE_LOADING, false);
      });
    }
  }
  
};
</script>
 
<style lang="less" scoped>
 
.complex-table{
    /deep/ .el-button--text{
     color: #cfaa72 !important;
     padding: 0 5PX 0 0; 
     &:last-child {
      padding-right: 0px;
     }
   }

   /deep/.el-table td, .el-table th{
    height: 0.5rem;
    padding: 0;
    .cell{
      line-height: 1.2;
      padding: 0 4PX;
    }
   }
   /deep/.el-table__header-wrapper th{
    height:  0.5rem;
    .cell{
      font-size:16Px;
      line-height: 1.2;
    }
   }
   /deep/.el-table__body-wrapper{
    max-height: 5.7rem;
    overflow-y: auto;
  }
   /deep/ .kui-table-footer .el-pagination .el-pager .active{
 
    border-color: #cfaa72;
    background: #cfaa72;
   }

   /deep/ .kui-table-footer{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
    margin-bottom: 20px;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    .el-pagination .el-pagination__jump, .el-pager li{
      font-size: 14px;
    }
   }
}

</style>



// WEBPACK FOOTER //
// src/components/common/complexTable.vue